import { Loading } from 'element-ui';
 
let loadingCount = 0;
let loading;
 

function startLoading(targetEle)
{
    //debugger
    if (loadingCount === 0) {
        loading = Loading.service({
            lock: true,
            text: '加载中...',                   //可以自定义文字

            spinner:'el-icon-loading',           //自定义加载图标类名
            background: '#394765',   //遮罩层背景色
            target: document.getElementById(targetEle) // 设置加载动画区域
        });
    }
    loadingCount += 1;
    
};


 
const endLoading = () => {
    
    if (loadingCount <= 0) {
        return;
        }
 
     loadingCount -= 1;
    if (loadingCount === 0) {
        loading.close();
    }
    //debugger
};
let fullScreenLoading;

const fullScreenStartLoading = () => {
    
  fullScreenLoading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.7)'
  });
};

const fullScreenEndLoading = () => {
    fullScreenLoading.close();
};


export{
    startLoading,
    endLoading,
    fullScreenStartLoading,
    fullScreenEndLoading
};



// WEBPACK FOOTER //
// ./src/js/loading.js